module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.one')))]), _vm._v(" "), _c('v-tab', [_vm._v(_vm._s(_vm.$t('tabs.two')))]), _vm._v(" "), _c('v-tabs-items', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('v-tab-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.invoicesRequest.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.getInvoices
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "subheading hidden-xs-only"
  }, [_vm._v("\n            Invoices\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": "",
      "small": "",
      "disabled": !(_vm.selectedInvoices) || _vm.selectedInvoices.length === 0
    },
    on: {
      "click": function($event) {
        _vm.showCreateStatement = true
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("\n            " + _vm._s(_vm.$t('buttons.createstatement')) + "\n          ")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.launchInvoiceDialog({
          relationshipId: _vm.relationshipId
        })
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")]), _vm._v("Invoice")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.mdAndDown,
      "width": 800
    },
    model: {
      value: (_vm.showCreateStatement),
      callback: function($$v) {
        _vm.showCreateStatement = $$v
      },
      expression: "showCreateStatement"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": "",
      "dark": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v("\n                    " + _vm._s(_vm.$t('dialogs.titles.statement')) + "\n                  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showCreateStatement = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.selectedInvoices && _vm.selectedInvoices.length > 0) ? _c('statement', {
    attrs: {
      "touch": _vm.statementToucher,
      "relationship-id": _vm.relationshipId,
      "invoices": _vm.selectedInvoices
    },
    on: {
      "close": function($event) {
        _vm.showCreateStatement = false
      }
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('invoice-list', _vm._g({
    staticClass: "invoice-list",
    attrs: {
      "invoices": _vm.pagedInvoices,
      "selected-invoice-ids": _vm.selectedInvoiceIds,
      "actions": _vm.invoiceActions,
      "withStatus": true,
      "loading": _vm.invoicesRequest.loading
    },
    on: {
      "selected": _vm.setSelected
    }
  }, _vm.invoiceEvents)), _vm._v(" "), (_vm.invoicesRequest.status === 200 && _vm.invoices.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_vm._v("\n              No invoices found\n            ")])], 1) : _c('v-subheader', [_vm._v("Showing " + _vm._s(Math.min(_vm.itemsToShow, _vm.invoices.length)) + " of " + _vm._s(_vm.invoices.length) + " Invoices")]), _vm._v(" "), _c('v-list-tile', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasMore),
      expression: "hasMore"
    }],
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.itemsToShow += _vm.pageSize
      }
    }
  }, [_vm._v("Load more")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', [_c('statement-list', {
    attrs: {
      "touch": _vm.statementListToucher,
      "relationship-id": _vm.relationshipId
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-715be426","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientInvoices.vue
// module id = 1464
// module chunks = 9